import {SET_USER, USER_CHANGE_PASSWORD_REQUEST, USER_CLEAR_ERROR} from './constants'

export function setUserState(newUserState) {
  return {type: SET_USER, newUserState}
}

export function putUserChangePassword(newPasswordState) {
  return {type: USER_CHANGE_PASSWORD_REQUEST, newPasswordState}
}

export function clearError() {
  return {type: USER_CLEAR_ERROR}
}



// WEBPACK FOOTER //
// ./src/actions/user.js